module.exports = __webpack_public_path__ + "static/media/independencia.4811828d.svg";